import IItinerary from 'interfaces/IItinerary';
import RestService from './RestService';

export default class ItineraryService extends RestService<IItinerary> {
  constructor() {
    super('itineraries');
  }
}
